<template>
  <el-cascader
    ref="cascader"
    v-cascader-click-select
    :value="value"
    :options="options"
    :props="cascaderProps"
    :popper-class="popperClass"
    v-bind="$attrs"
    v-on="cascaderListeners"
  />
</template>

<script>
export default {
  name: 'AreaCascader',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Array],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    checkStrictly: {
      type: Boolean,
      default: true
    },
    emitPath: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cascaderProps () {
      return {
        expandTrigger: 'hover',
        multiple: this.multiple,
        value: 'uuid',
        label: 'areaName',
        children: 'children',
        checkStrictly: this.checkStrictly,
        emitPath: this.emitPath
      };
    },
    popperClass () {
      return this.multiple ? '' : 'area-cascader-single-panel';
    },
    cascaderListeners () {
      return Object.assign({}, this.$listeners, {
        input: value => this.$emit('input', value),
        change: this.handleChange
      });
    }
  },
  methods: {
    handleChange (value) {
      this.$emit('change', value);

      // 单选允许选择任意层级，Element UI 不会自动收起，需在值确定后主动关闭面板。
      if (!this.multiple) this.$refs.cascader.toggleDropDownVisible(false);
    }
  }
};
</script>
